/**
 * Call "Get Credentials" API.
 * @see https://docs.microsoft.com/azure/static-web-apps/user-information
 */
export async function getClientPrincipal($http) {
    const { clientPrincipal } = await $http.$get('/.auth/me');
    return clientPrincipal;
}
